import { render, staticRenderFns } from "./CorrectiveActionRequestsTable.vue?vue&type=template&id=4c4e8445"
import script from "./CorrectiveActionRequestsTable.vue?vue&type=script&lang=js"
export * from "./CorrectiveActionRequestsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports